module.exports = __webpack_public_path__ + "img/logo.8dab38a9.jpg";